/*
 * Created Date: 15-03-2024, 11:06:54 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Fri Mar 15 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import BaseService from '@Core/axios/BaseService'

class AdminStudent extends BaseService {
	BASE_ENDPOINT = '/lms/api/v1/admin/students'
}

const adminStudentService = new AdminStudent()

export default adminStudentService
